import React from 'react';

const renderStrong = (...chunk: string[]) => <strong>{chunk}</strong>;
const renderEm = (...chunk: string[]) => <em>{chunk}</em>;
const renderP = (...chunk: string[]) => <p>{chunk}</p>;
const renderUl = (...chunk: string[]) => <ul>{chunk}</ul>;
const renderLi = (...chunk: string[]) => <li>{chunk}</li>;
const renderSpan = (...chunk: string[]) => <span>{chunk}</span>;

const renderSpanNoMobile = (...chunk: string[]) => (
  <span className="hide-mobile d-none d-lg-inline">{` ${chunk}`}</span>
);
const renderBr = () => <br />;

export {
  renderStrong,
  renderEm,
  renderP,
  renderBr,
  renderUl,
  renderLi,
  renderSpanNoMobile,
  renderSpan,
};
